import { LongPressContext } from 'global/cnr/contexts/LongPressContext'
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import { useBreadcrumbs } from 'global/cnr/contexts/useHelpers/useBreadcrumbs'
import { gEnums } from 'global/enums/globalEnums'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper'
import _ from 'lodash'
import SportsEditMatchProvider from 'projectSpecific/sports/cnr/contexts/SportsEditMatchContext'
import SportsMatchProvider, { SportsMatchContext } from 'projectSpecific/sports/cnr/contexts/SportsMatchContext'
import { SportsRtMatchContext } from 'projectSpecific/sports/cnr/contexts/SportsRtMatchContext'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import { matchExternalTypes, matchModifyTypes, matchUpdateTypes } from 'projectSpecific/sports/cnr/reducers/SportsSeasonReducer'
import { CreateMatchResult_withProvider } from 'projectSpecific/sports/create/CreateMatchResult'
import { useContext, useEffect, useMemo, useState } from 'react'
import { Icon } from 'semantic-ui-react'
import MatchDetailsUpdate from './MatchDetailsUpdate'
import { MatchPendings } from './MatchPendings'
import { PlayoffLocations } from './PlayoffLocations'
import { ParentContext } from 'global/cnr/contexts/ParentContext'
import { _realtimeMatchTypes, useRealtimeUpdates } from 'projectSpecific/sports/useHelpers/useRealtimeResults'

const _baseTypes_match = {
  options: 'options',
  matchResultTypes: 'matchResultTypes',
  matchResult: 'matchResult',
  matchExternal: 'matchExternal',
  matchEdit: 'matchEdit',
  matchModifications: 'matchModifications',
  matchPendings: 'matchPendings',
  matchOption: 'matchOption',
  playoffLocations: 'playoffLocations',
  matchDayScoring: 'matchDayScoring',
  realtimeScoring: 'realtimeScoring',
}

const _optionTypes_admin = {
  matchResults: 'matchResults',
  matchExternal: 'matchExternal',
  matchModifications: 'matchModifications',
  matchEdit: 'matchEdit',
  matchPendings: 'matchPendings',
  playoffLocations: 'playoffLocations',
  matchDayScoring: 'matchDayScoring',
  realtimeScoring: 'realtimeScoring',
}

const _optionTypes_public = {
  matchResults: 'matchResults',
}

const _matchResultTypes = {
  matchScores: 'matchScores',
  setScores: 'setScores',
}

const _matchRealtimeTypes_on = {
  turnOn: 'turnOn',
  remove: 'remove',
  removeAll: 'removeAll',
}

const _matchRealtimeTypes_off = {
  turnOff: 'turnOff',
  remove: 'remove',
  removeAll: 'removeAll',
}

const _matchMatchDayTypes = {
  remove: 'remove',
  removeAll: 'removeAll',
}


const _tempAllow = true

const MatchOptionsSquares = ({ match_true, matchDisplayType }) => {

  const { deleteMatch_realtime } = useRealtimeUpdates()

  const appUserAccess = useAppUserAccess()
  const { isSuperAdminDeveloper: isSda, displayName } = appUserAccess ?? {}

  const parentContext = useContext(ParentContext);
  const { states, fns, fn_cls } = parentContext ?? {}
  const { app_state, currentSettings_state, paps_state } = states ?? {}
  const { pathViews } = paps_state ?? {}
  const { matches: matchKey } = pathViews ?? {}

  const longPressContext = useContext(LongPressContext);
  const { longPress_handlers } = longPressContext ?? {}

  const sportsMatchContext = useContext(SportsMatchContext)
  const { sportsMatch_state, sportsMatch_handlers } = sportsMatchContext ?? {}
  const { match_true: mt, matchAllows } = sportsMatch_state ?? {}

  const sportsRtMatchContext = useContext(SportsRtMatchContext)
  const { sportsRtMatch_state, sportsRtMatch_handlers } = sportsRtMatchContext ?? {}
  const { showRealtimeScoring, match_rt } = sportsRtMatch_state ?? {}

  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext
  const { details_info, matches_info } = sportsSeason_state ?? {}
  const { details } = details_info ?? {}
  const { matches } = matches_info ?? {}
  const { sportsScoringAuthType } = details ?? {}

  const [allGroups, setAllGroups] = useState([])

  const currentMatch = useMemo(() => {
    if (match_true) {
      return match_true
    } else {
      const _match = matches?.[matchKey]
      if (_match) {
        return _match
      }
      return {}
    }
  }, [match_true, matchKey])

  const currentGroup = allGroups?.[allGroups.length - 1]

  const { _results } = currentMatch ?? {}
  const { complete: complete_true, allowMatchResults } = _results ?? {}

  const iconProps = useMemo(() => {
    let icon = 'user'
    let color = 'green'
    let caption = 'Public'

    switch (sportsScoringAuthType) {
      case gEnums.sportsScoringAuthTypes.authUser:
        icon = 'user secret'
        color = 'red'
        caption = displayName ? displayName : 'Authorized Only'
        break;
      case gEnums.sportsScoringAuthTypes.appUser:
        icon = 'user'
        color = 'blue'
        caption = displayName ? displayName : 'App Users Only'
        break;
      case gEnums.sportsScoringAuthTypes.public:
        icon = 'users'
        color = 'green'
        caption = 'Public'
        break;
    }
    return { icon, color, caption }
  }, [sportsScoringAuthType])

  const matchInfoItems = useMemo(() => {
    if (isSda) {
      return _.omit(_baseTypes_match, [_optionTypes_admin])
    }
    return _baseTypes_match
  })

  // runs at the start, setAllGroups
  useEffect(() => {
    const _allGroups = []
    _allGroups.push({
      key: _baseTypes_match.options,
      value: '',
      caption: _.startCase(_baseTypes_match.options),
      menuItems: isSda ? _optionTypes_admin : _optionTypes_public
    })
    setAllGroups(_allGroups)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, []);

  const addToGroup = (group) => {
    const _allGroups = _.clone(allGroups)
    _allGroups.push(group)
    setAllGroups(_allGroups)
  }

  const backLinks = useMemo(() => {
    const bl = _.map(
      allGroups.slice(0, -1),
      (group) => (
        {
          key: group.key || 0,
          caption: group.caption
        }
      )
    );
    return bl
  }, [allGroups])

  const goBack = () => {
    const _allGroups = _.clone(allGroups)
    if (_allGroups.length <= 1) { return; }
    const all_groups = _allGroups.slice(0, -1)
    setAllGroups(all_groups)
  }

  const goBackTo = (index) => {
    const _allGroups = _.clone(allGroups)
    if (index < 0 || index >= _allGroups.length) return;
    if (_allGroups.length <= 1) return; // ⛔ root protected 
    const all_groupz = _allGroups.slice(0, index + 1)
    setAllGroups(all_groupz)
  }

  const bcrb = useBreadcrumbs({ items: backLinks, onClick: goBackTo })

  const onClick_optionType = (value) => {
    switch (value) {
      case _optionTypes_admin.matchResults:
        return addToGroup({ key: _baseTypes_match.matchResultTypes, value: value, caption: _.startCase(value), menuItems: _matchResultTypes })

      case _optionTypes_admin.realtimeScoring:
        return addToGroup({ key: _baseTypes_match.realtimeScoring, value: value, caption: _.startCase(value), menuItems: showRealtimeScoring ? _matchRealtimeTypes_off : _matchRealtimeTypes_on })

      case _optionTypes_admin.matchDayScoring:
        return addToGroup({ key: _baseTypes_match.matchDayScoring, value: value, caption: _.startCase(value), menuItems: _matchMatchDayTypes })


      case _optionTypes_admin.matchExternal:
        if (!isSda) { return; }
        return addToGroup({ key: _baseTypes_match.matchExternal, value: value, caption: _.startCase(value), menuItems: _optionTypes_admin })

      case _optionTypes_admin.matchModifications:
        if (!isSda) { return; }
        return addToGroup({ key: _baseTypes_match.matchModifications, value: value, caption: _.startCase(value), menuItems: _optionTypes_admin })

      case _optionTypes_admin.matchPendings:
        if (!isSda) { return; }
        return addToGroup({ key: _baseTypes_match.matchPendings, value: value, caption: _.startCase(value), menuItems: _optionTypes_admin })

      case _optionTypes_admin.playoffLocations:
        if (!isSda) { return; }
        return addToGroup({ key: _baseTypes_match.playoffLocations, value: value, caption: _.startCase(value), menuItems: _optionTypes_admin })

      case _optionTypes_admin.matchEdit:
        if (!isSda) { return; }
        return addToGroup({ key: _baseTypes_match.matchEdit, value: value, caption: _.startCase(value), menuItems: _optionTypes_admin })
    }
  }

  const onClick_matchResultType = (value) => {
    addToGroup({ key: _baseTypes_match.matchResult, value: value, caption: _.startCase(value), menuItems: _matchResultTypes })
  }

  const onClick_matchOptions = (value) => {
    addToGroup({ key: _baseTypes_match.matchOption, value: value, caption: _.startCase(value), menuItems: _matchResultTypes })
  }

  const onClick_realTime = (item) => {
    switch (item) {
      case _matchRealtimeTypes_on.turnOn:
      case _matchRealtimeTypes_off.turnOff:
        sportsRtMatch_handlers.handleShow_rtMatch()
        longPress_handlers && longPress_handlers.handleCancel()
        return;
      case _matchRealtimeTypes_on.remove:
      case _matchRealtimeTypes_off.remove:
        deleteMatch_realtime({ match_rt: match_true, realtimeMatchType: _realtimeMatchTypes.realtimeResults, callback: longPress_handlers && longPress_handlers.handleCancel })
        return;
      case _matchRealtimeTypes_on.removeAll:
      case _matchRealtimeTypes_off.removeAll:
        deleteMatch_realtime({ match_rt: match_true, removeAll: true, realtimeMatchType: _realtimeMatchTypes.realtimeResults, callback: longPress_handlers && longPress_handlers.handleCancel })
        return;
    }
  }

  const onClick_matchDay = (item) => {
    switch (item) {
      case _matchMatchDayTypes.remove:
        deleteMatch_realtime({ match_rt: match_true, realtimeMatchType: _realtimeMatchTypes.matchDayResults, callback: longPress_handlers && longPress_handlers.handleCancel })
        return;
      case _matchMatchDayTypes.removeAll:
        deleteMatch_realtime({ match_rt: match_true, removeAll: true, realtimeMatchType: _realtimeMatchTypes.matchDayResults, callback: longPress_handlers && longPress_handlers.handleCancel })
    }

  }

  const icn = (active) => <Icon name={active ? 'check circle outline' : 'ban'} color={active ? 'blue' : 'red'} />

  const fnAltContent_options = (item) => {
    let icns = []
    switch (item) {
      case _optionTypes_admin.matchResults:
      case _optionTypes_admin.realtimeScoring:
      case _optionTypes_admin.matchDayScoring:
        icns.push(<Icon name={iconProps.icon} color={iconProps.color} title={iconProps.caption} />)
        icns.push(icn(!complete_true))
        break;
      case _optionTypes_admin.matchExternal:
      case _optionTypes_admin.matchModifications:
      case _optionTypes_admin.matchPendings:
      case _optionTypes_admin.playoffLocations:
      case _optionTypes_admin.matchEdit:
        icns.push(icn(isSda))
        break;
      default:
      // nothing
    }
    return <div style={{ display: 'flex', columnGap: '1em', justifyContent: 'space-between', alignItems: 'baseline' }}>{icns}</div>
  }

  const fnSubContent = (item) => {
    switch (item) {
      case _matchResultTypes.matchScores:
        return <div>{`ex. 3-1`}</div>
      case _matchResultTypes.setScores:
        return <div>{`ex. 25-21, 20-25, 25-18, 25-23`}</div>
    }

  }

  // squares based on currentGroup
  const squares_options = (menuItems) => <ItemMenuSquares menuItems={menuItems} imsType={_imsTypes.inline} onClick={onClick_optionType} fn_altContent={fnAltContent_options} />
  const squares_matchResultType = (menuItems) => <ItemMenuSquares menuItems={menuItems} imsType={_imsTypes.inline} onClick={onClick_matchResultType} fn_subContent={fnSubContent} />
  const squares_matchModifications = (menuItems) => <ItemMenuSquares menuItems={menuItems} imsType={_imsTypes.inline} onClick={onClick_matchOptions} />
  const squares_matchOptions = (menuItems) => <ItemMenuSquares menuItems={menuItems} imsType={_imsTypes.inline} onClick={onClick_matchOptions} />
  const squares_realtime = (menuItems) => <ItemMenuSquares menuItems={menuItems} imsType={_imsTypes.inline} onClick={onClick_realTime} />
  const squares_matchDay = (menuItems) => <ItemMenuSquares menuItems={menuItems} imsType={_imsTypes.inline} onClick={onClick_matchDay} />

  const content_currentGroup = () => {
    if (allGroups) {
      const { key, menuItems, value } = currentGroup ?? {}
      switch (key) {
        case _baseTypes_match.options:
          return squares_options(menuItems)

        case _baseTypes_match.matchResultTypes:
          if (allowMatchResults || _tempAllow) {
            return squares_matchResultType(menuItems)
          } else {
            return <div style={{ padding: '1em' }}>{'Match Results not allowed. This match is in the future.'}</div>
          }

        case _baseTypes_match.matchExternal:
          return squares_matchModifications(matchExternalTypes)
        case _baseTypes_match.matchModifications:
          return squares_matchModifications(matchModifyTypes)
        case _baseTypes_match.matchEdit:
          return squares_matchOptions(matchUpdateTypes)
        case _baseTypes_match.matchResult:
          return <CreateMatchResult_withProvider
            match={currentMatch}
            matchKey={currentMatch?._itemKey}
            matchResultType={value}
          />
        case _baseTypes_match.matchPendings:
          return <MatchPendings />
        case _baseTypes_match.playoffLocations:
          return <PlayoffLocations />
        case _baseTypes_match.realtimeScoring:
          if (allowMatchResults || _tempAllow) {
            return squares_realtime(showRealtimeScoring ? _matchRealtimeTypes_off : _matchRealtimeTypes_on)
          } else {
            return <div style={{ padding: '1em' }}>{'Match Results not allowed. This match is in the future.'}</div>
          }
        case _baseTypes_match.matchDayScoring:
          return squares_matchDay(_matchMatchDayTypes)
        case _baseTypes_match.matchOption:
          return <SportsMatchProvider match={currentMatch} matchKey={currentMatch._itemKey} matchUpdateType={value}>
            <SportsEditMatchProvider match={currentMatch} matchUpdateType={value}>
              <MatchDetailsUpdate match={currentMatch} matchUpdateType={value} />
            </SportsEditMatchProvider>
          </SportsMatchProvider>
      }
    }
  }

  const header_top = () => {
    const currentGroup = allGroups?.[allGroups.length - 1]
    const { caption, key } = currentGroup ?? {}
    const _caption = caption || _.startCase(key)
    return <div className='swr-header'>
      {bcrb}
      <div className='swr-header-cap'>
        {allGroups.length > 1 && <Icon color={'blue'} name='arrow left' onClick={() => goBack()}></Icon>}
        {_caption}</div>
    </div>
  }

  const wrapper = () => <Wrapper
    topper={<div style={{ textAlign: 'center', padding: '.15em' }}>{`${currentMatch?._status?.matchName} - ${displayName || 'Public'}`}</div>}
    header={header_top()}
    content={content_currentGroup()}
    wrapperType={wrapperTypes.padded}
  ></Wrapper>

  return wrapper()
}

export default MatchOptionsSquares